import Box from '@mui/material/Box'
import ReactMarkdown from 'react-markdown'
import rehypeSanitize from 'rehype-sanitize'
import privacy from './terms/v2.0.md'

const TermsOfUse = ({ compact = false }) => {
  return (
    <Box
      sx={
        compact
          ? {
              '& h1': {
                fontSize: '1.8rem',
                mt: 0,
                mb: 1.5,
              },
              '& h2': {
                fontSize: '1.35rem',
                mt: 2.5,
                mb: 1,
              },
              '& h3': {
                fontSize: '1.1rem',
                mt: 2,
                mb: 0.75,
              },
              '& p': {
                fontSize: '0.9rem',
                lineHeight: 1.6,
                mb: 1.25,
              },
              '& li': {
                fontSize: '0.9rem',
                lineHeight: 1.6,
                mb: 0.5,
              },
              '& ul, & ol': {
                pl: 3,
                mb: 1.25,
              },
              '& hr': {
                my: 2,
              },
            }
          : {
              maxWidth: 900,
              mx: 'auto',
              px: 3,
              py: 4,
              '& h1': {
                fontSize: '2.5rem',
                fontWeight: 700,
                mb: 2,
                mt: 0,
                lineHeight: 1.2,
              },
              '& h2': {
                fontSize: '2rem',
                fontWeight: 700,
                mt: 4,
                mb: 2,
                lineHeight: 1.25,
              },
              '& h3': {
                fontSize: '1.4rem',
                fontWeight: 600,
                mt: 3,
                mb: 1.5,
                lineHeight: 1.3,
              },
              '& p': {
                fontSize: '1rem',
                lineHeight: 1.7,
                mb: 2,
                mt: 0,
              },
              '& ul, & ol': {
                pl: 3,
                mb: 2,
                mt: 0,
              },
              '& li': {
                mb: 1,
                lineHeight: 1.7,
              },
              '& hr': {
                border: 0,
                borderTop: '1px solid rgba(0,0,0,0.12)',
                my: 3,
              },
              '& strong': {
                fontWeight: 700,
              },
            }
      }
    >
      <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{privacy}</ReactMarkdown>
    </Box>
  )
}

export default TermsOfUse
